import {
	eventsHeroImage,
	eventsHeroMobileImage,
	educationImage,
	volunteerImage,
} from "../images";

export const heroData = [
	{
		imageSource: [eventsHeroImage, eventsHeroMobileImage],
		heading: "Events",
	},
];

export const eventsData = [
	{
		title: "Event1",
		imageSource: educationImage,
		heading: "Event 1",
		description: ["Event Coming Soon"],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",
		linkText: "Join us",
	},
	{
		title: "Event 2",
		imageSource: volunteerImage,
		heading: "Event Coming Soon",
		description: [
			"There is an urgent need for a deeper learning approach with students, to allow them get engaged in critical thinking and problem solving. The approach should aid students with skills necessary to provide solutions to global problems and become successful in the workforce.",
		],
		eventDetails: {
			date: "15th, June 2021",
			duration: "10am - 11am",
			price: "Free",
		},
		link: "http://3hfoundation.eventbrite.com",
		linkText: "Join us",
	},
];
